import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main className="pt-[110px]">{children}</main>
      <Footer />
    </>
  );
}
